// src/api/service/admin/admin_users.service.ts

import { apiClient } from "../../config";
import { env } from "../../../config/env";
import { User, SuccessResponse } from "../../interface/user.interface";

interface GetUsersResponse {
  success: boolean;
  data: {
    users: User[];
  };
}

class AdminUsersService {
  /**
   * 📌 LIST USERS
   */
  async getUsers(): Promise<GetUsersResponse> {
    const response = await apiClient.get<GetUsersResponse>(
      env.USERS.ADMIN.BASE
    );
    return response.data;
  }

  /**
   * 🚫 BAN USER
   */
  async banUser(email: string): Promise<SuccessResponse> {
    const response = await apiClient.post<SuccessResponse>(
      env.USERS.ADMIN.BAN(email)
    );
    return response.data;
  }

  /**
   * ✅ UNBAN USER
   */
  async unbanUser(email: string): Promise<SuccessResponse> {
    const response = await apiClient.post<SuccessResponse>(
      env.USERS.ADMIN.UNBAN(email)
    );
    return response.data;
  }

  /**
   * ➕ ADD ROLE
   */
  async addUserRole(
    email: string,
    role_id: string
  ): Promise<SuccessResponse> {
    const response = await apiClient.post<SuccessResponse>(
      env.USERS.ADMIN.ADD_ROLE(email),
      { role_id }
    );
    return response.data;
  }

  /**
   * ➖ REMOVE ROLE
   */
  async removeUserRole(
    email: string,
    role_id: string
  ): Promise<SuccessResponse> {
    const response = await apiClient.post<SuccessResponse>(
      env.USERS.ADMIN.REMOVE_ROLE(email),
      { role_id }
    );
    return response.data;
  }

  
}

export const adminUsersService = new AdminUsersService();